import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent2, requireStates } from "util";

const initialStates = [
  {
    name: "app.registration.product.inventory.modify",
    url: "/modificar",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/index.js